<div class="training-tools-container">
  <div class="tips-container">
    <div class="training-tool-title">
      <mat-icon class="material-symbols-outlined" color="primary"
        >school</mat-icon
      >
      <span class="subtitle-01">
        {{ isEvaluationMode ? 'Evaluation' : 'Training Assistant' }}
      </span>
    </div>
    <button
      *ngIf="!isEvaluationMode && (calculated$ | async)"
      mat-stroked-button
      class="action-button show-shapes-button"
      color="primary"
      (click)="showHints()"
      [disabled]="(isShowingHints$ | async) || (shouldDisableTools$ | async)"
    >
      <mat-icon class="material-symbols-outlined lightbulb">lightbulb</mat-icon>
      SHOW HINTS
    </button>
  </div>

  @if (!isEvaluationMode) {
    @if (calculated$ | async) {
      <div class="update-score-container">
        <div class="training-tool-results">
          <span class="score-text headline-03" [style.color]="color$ | async"
            >{{ latestScore$ | async }}%</span
          >
          <div *ngIf="passMark" class="pass-mark-text body-02">
            Pass mark: {{ passMark }}%
          </div>
          <div class="progress-bar-container">
            <h3-progress-bar
              [categories]="progress$ | async"
              [isLoading]="isLoading$ | async"
            >
            </h3-progress-bar>
          </div>
        </div>
        <button
          mat-stroked-button
          class="action-button"
          color="primary"
          (click)="calculateScore('UPDATE SCORE')"
          [disabled]="shouldDisableTools$ | async"
        >
          <mat-icon class="action-button-icon" color="primary"
            >refresh</mat-icon
          >
          UPDATE SCORE
        </button>
      </div>
    } @else {
      <div>
        <span class="body-02 action-hint-text"
          >Calculate your score to save your first attempt and get access to the
          training tools</span
        >
        <button
          class="action-button"
          mat-stroked-button
          color="primary"
          (click)="calculateScore('CALCULATE SCORE')"
          [disabled]="shouldDisableTools$ | async"
        >
          CALCULATE SCORE
        </button>
      </div>
    }
  }
</div>
